import { ArrowUpRight } from "lucide-react";
import { services, waLink } from "@/content/siteContent";
import { SectionHeading } from "./SectionHeading";
import { Medallion } from "./Medallion";
import { Reveal } from "./Reveal";

export default function Services() {
  return (
    <section id="servicos" className="bg-cream py-24 md:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          light
          chapter={services.chapter}
          microtitle={services.microtitle}
          titleA={services.titleA}
          titleB={services.titleB}
        />

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.items.map((service, i) => (
            <Reveal key={service.num} delay={(i % 3) * 0.1}>
              <article
                className="card-industrial group flex h-full flex-col p-7"
                data-testid={`service-card-${service.num}`}
              >
                <div className="mb-6 flex items-start justify-between">
                  <Medallion icon={service.icon} size={68} testId={`service-medallion-${service.num}`} />
                  <span className="font-display text-sm font-extrabold tracking-[0.2em] text-brand">{service.num}</span>
                </div>
                <h3 className="font-display text-lg font-extrabold leading-snug tracking-wide text-paper">
                  {service.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-mist">{service.desc}</p>
                <a
                  href={waLink(service.wa)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex items-center gap-2 font-display text-[0.7rem] font-extrabold tracking-[0.16em] text-brand transition-colors duration-300 hover:text-brand-light"
                  data-testid={`service-cta-${service.num}`}
                >
                  SOLICITAR ORÇAMENTO
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
